import * as Sentry from '@sentry/react';

export interface MutationContext {
  operation: string;
  table?: string;
  entityId?: string;
  employeeId?: string;
  fileType?: string;
  fileSize?: number;
  targetStatus?: string;
}

function toError(error: unknown): Error {
  if (error instanceof Error) return error;
  if (error && typeof error === 'object') {
    const obj = error as Record<string, unknown>;
    const message = obj.message ?? obj.msg ?? JSON.stringify(error);
    const err = new Error(String(message));
    if (obj.code) err.name = String(obj.code);
    return err;
  }
  return new Error(String(error));
}

export function captureMutationError(error: unknown, context: MutationContext) {
  const safeError = toError(error);
  Sentry.captureException(safeError, {
    tags: {
      mutation_operation: context.operation,
      ...(context.table && { mutation_table: context.table }),
    },
    extra: {
      operation: context.operation,
      ...(context.table && { table: context.table }),
      ...(context.entityId && { entityId: context.entityId }),
      ...(context.employeeId && { employeeId: context.employeeId }),
      ...(context.fileType && { fileType: context.fileType }),
      ...(context.fileSize && { fileSize: context.fileSize }),
      ...(context.targetStatus && { targetStatus: context.targetStatus }),
    },
  });
}

export function setErrorUser(id: string) {
  Sentry.setUser({ id });
}

export function clearErrorUser() {
  Sentry.setUser(null);
}
